import React from 'react'

const CaseStudies = () => {
    return (<section id="casestudies">
<h2>Appsmith - Case Study</h2>
<iframe className='casestudy-iframe' src="https://www.figma.com/embed?embed_host=share&url=https%3A%2F%2Fwww.figma.com%2Fproto%2FVhXZZQFB2iS1RsGNidf9K6%2FAppsmith-Case-Study%3Fnode-id%3D103%253A394%26starting-point-node-id%3D103%253A394%26scaling%3Dscale-down" allowFullScreen title="appsmith-casestudy"></iframe>

    </section>
        
)
}

export default CaseStudies